export const AUTOMATION_COOKIE_NAME = 'sortlist-automation';

export const isBrowser = () => typeof window !== 'undefined';

export const isAutomation = () => {
  if (!isBrowser()) return false;
  const userAgent = navigator.userAgent.toLowerCase();
  const _isAutomation = isAutomationUserAgent(userAgent);
  const hasAutomationCookie = document.cookie.includes(`${AUTOMATION_COOKIE_NAME}=true`);

  return _isAutomation || hasAutomationCookie;
};

const BLOCKED_BOT_UA_PATTERNS: RegExp[] = [
  /bot/i,
  /spider/i,
  /crawler/i,
  /slurp/i,
  /adsbot/i,
  /yandex/i,
  /monitor/i,
  /pingdom/i,
  /baiduspider/i,
  /semrush/i,
  /applebot/i,
  /sebot/i,
  /linkedinbot/i,
  /googlebot/i,
  /adsbot-google/i,
  /mediapartners-google/i,
  /google-site-verification/i,
  /feedfetcher-google/i,
  /apis-google/i,
  /google-read-aloud/i,
  /ahrefsbot/i,
  /semrushbot/i,
  /mj12bot/i,
  /twitterbot/i,
  /bingbot/i,
  /duckduckbot/i,
  /facebookexternalhit/i,
];

export const isAutomationUserAgent = (userAgent?: string | null): boolean => {
  if (userAgent == null) return false;
  return userAgent.includes('sortlist-automation');
};

export const isBotUserAgent = (userAgent?: string | null): boolean => {
  if (userAgent == null) return false;
  return BLOCKED_BOT_UA_PATTERNS.some((pattern) => pattern.test(userAgent));
};

const IPV4_REGEX = /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;
const IPV6_REGEX = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}$/;

export const isIP = (value: string): number => {
  if (IPV4_REGEX.test(value)) return 4;
  if (IPV6_REGEX.test(value)) return 6;
  return 0;
};
